import React, { FC, memo } from 'react';
import { formatAiProviderName, getAiProviderIcon } from '../../utils/aiProvider';
import IconLabel from '../IconLabel';

type AiProviderLabelProps = {
  aiProvider: string;
};

const AiProviderLabel: FC<AiProviderLabelProps> = memo(({ aiProvider }) => {
  const name = formatAiProviderName(aiProvider);
  const iconUrl = getAiProviderIcon(aiProvider);
  return <IconLabel name={name} iconUrl={iconUrl} />;
});

export default AiProviderLabel;
